/**
 * Contact API Service
 *
 * Endpoints:
 * POST /contact - Kontaktformular (öffentlich, kein Login nötig)
 */

import { post } from '../client';

/**
 * Kontaktformular absenden
 * @param {{ name: string, email: string, subject: string, message: string }} payload
 * @returns {Promise<{success: boolean, data?: {message: string}, error?: object}>}
 *
 * Validierung (Backend): alle 4 Felder Pflicht,
 * name <= 100, subject <= 200, message <= 5000 Zeichen, email muss gültig sein
 * Errors: 400 VALIDATION_ERROR, 502 MAIL_DELIVERY_FAILED
 */
export const sendMessage = async ({ name, email, subject, message }) => {
  return post('/contact', { name, email, subject, message });
};
